import React, { Component } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import {
  Icon, Image, Menu, Sidebar,
} from 'semantic-ui-react';
import ButtonLinkRoomConference from '../../../components/forms/ButtonLinkRoomConference';
import FooterLayout from './FooterLayout';

class MobilePageLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpened: false,
    };

    this.handleSidebarHide = this.handleSidebarHide.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleSidebarHide = () => this.setState({ sidebarOpened: false })

  handleToggle = () => this.setState({ sidebarOpened: true })

  render() {
    const {
      children, auth, authenticationLogout, Media,
    } = this.props;
    const { sidebarOpened } = this.state;

    return (
      <Media className="fresnel-container-sidebar" as={Sidebar.Pushable} at="mobile">
        <Sidebar.Pushable>
          <Sidebar
            as={Menu}
            animation="overlay"
            inverted
            color="teal"
            onHide={this.handleSidebarHide}
            vertical
            visible={sidebarOpened}
          >
            <Menu.Item header>
              <div>
                <Image size="mini" src={auth.data && auth.data.avatar} avatar />
                <span
                  style={{ marginLeft: '5px' }}
                >
                  {auth.data && auth.data.prefijo}
                  {' '}
                  {auth.data && auth.data.nombre}
                  {' '}
                  {auth.data && auth.data.apellido}
                </span>
              </div>
            </Menu.Item>
            <Menu.Item as={Link} to="/" onClick={this.handleSidebarHide}>
              <Icon name="heartbeat" />
              Dashboard
            </Menu.Item>
            <Menu.Item as={Link} to="/pacientes" onClick={this.handleSidebarHide}>
              <Icon name="address book outline" />
              Mis Pacientes
            </Menu.Item>
            <Menu.Item as={Link} to="/perfil" onClick={this.handleSidebarHide}>
              <Icon name="doctor" />
              Mi Perfil
            </Menu.Item>
            <Menu.Item>
              <ButtonLinkRoomConference />
            </Menu.Item>
            <Menu.Item onClick={() => authenticationLogout()}>
              Salir
            </Menu.Item>
          </Sidebar>

          <Sidebar.Pusher dimmed={sidebarOpened}>
            <Menu size="large" pointing color="teal" fixed="top" borderless inverted>
              <Menu.Item onClick={this.handleToggle}>
                <Icon name="sidebar" />
              </Menu.Item>
              <Menu.Item position="right" header>Doug Vet</Menu.Item>
            </Menu>
            { auth.isAuthorized && children }
            <FooterLayout />
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </Media>
    );
  }
}

MobilePageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  auth: PropTypes.any.isRequired.isRequired,
  authenticationLogout: PropTypes.func.isRequired,
  Media: PropTypes.node.isRequired,
};

export default MobilePageLayout;



// WEBPACK FOOTER //
// ./src/layouts/PageLayout/components/MobilePageLayout.js